import { useEffect, useState } from "react";
import "./custom-table.scss";
import { Table, Tag } from "antd";
const CustomTable = (props) => {
  //   const [searchText, setSearchText] = useState("");
  //   const [searchedColumn, setSearchedColumn] = useState("");
  const [data, setData] = useState([]);
  useEffect(() => {
    if (props.dataSource) setData([...props.dataSource] || []);
  }, [props.dataSource]);

  const handleTableChange = (pagination, filters, sorter) => {
    console.log(filters);
    console.log(data);
    if (filters.request_status) {
      const newData = props.dataSource.filter((ele) => {
        return filters.request_status.indexOf(ele.request_status + "") !== -1;
      });
      setData(newData);
    } else {
      setData(props.dataSource);
    }
  };
  return (
    <div className="table-container">
      <Table onChange={handleTableChange} {...props} dataSource={data} />
    </div>
  );
};
export default CustomTable;
